"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var IconCheckCircle_1 = require("../icon/IconCheckCircle");
var IconInfoCircle_1 = require("../icon/IconInfoCircle");
var IconExclamationCircle_1 = require("../icon/IconExclamationCircle");
var baseCns = ['br-flex', 'br-items-center', 'br-p-4', 'br-rounded', 'br-border', 'br-w-full'];
var typeCns = {
    success: ['br-bg-green-200', 'br-text-green-600', 'br-border-green-600'],
    info: ['br-bg-blue-200', 'br-text-blue-600', 'br-border-blue-600'],
    alert: ['br-bg-blue-50', 'br-text-blue-600', 'br-border-50-600'],
    error: ['br-bg-red-200', 'br-text-red-600', 'br-border-red-600']
};
var iconMap = {
    success: IconCheckCircle_1.IconCheckCircle,
    info: IconInfoCircle_1.IconInfoCircle,
    alert: IconExclamationCircle_1.IconExclamationCircle,
    error: IconExclamationCircle_1.IconExclamationCircle
};
var Message = function (_a) {
    var className = _a.className, type = _a.type, children = _a.children, unused = __rest(_a, ["className", "type", "children"]);
    var Icon = iconMap[type];
    var cns = typeCns[type];
    return (react_1.default.createElement("div", __assign({ className: (0, classnames_1.default)(baseCns, className, cns) }, unused),
        react_1.default.createElement("div", { className: (0, classnames_1.default)('br-mr-4') },
            react_1.default.createElement(Icon, null)),
        react_1.default.createElement("div", null, children)));
};
exports.Message = Message;
